import withReducer from 'app/store/withReducer';
import nBossConnection from 'modules/base/service/nBossConnection';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import AddMeasurementTaskButton from 'app/admin/common/component/AddMeasurementTaskButton';
import ShowChartButton from '../component/ShowChartButton';
import MeasurementTableService from '../service/MeasurementTableService';
import MergeMeasurementsButton from '../component/MergeMeasurementsButton';
import CloneMeasurementButton from '../component/CloneMeasurementButton';
import CreateDatasetButton from '../component/CreateDatasetButton';

const config = {
	key: 'measurementTable',
	topic: 'measurement',
	service: MeasurementTableService,
	editFormState: item => `/measurement/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['search', 'refresh', 'new'],
	toolbarButtonList: [{ key: 'merge', place: 'before', component: MergeMeasurementsButton }],
	rowAction: ['exportData', 'modify', 'delete'],
	rowButtonList: [{ key: 'cloneMeasurement', component: CloneMeasurementButton }, { key: 'createDatasetButton', component: CreateDatasetButton }, { key: 'showChart', component: ShowChartButton }],
	exportData: {
		tooltip: 'Export to XLSX',
		link: item => `${nBossConnection.basePath}measurementTableControl/exportToXlsx?id=${item.id}`
	},
	columns: [
		{
			key: 'name'
		}
	]
};

function MeasurementTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('measurementTable', reducer('measurementTable'))(MeasurementTable);